import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import usePageTitle from '../hooks/usePageTitle';
import ServicesMarquee from '../components/ServicesMarquee';
import useNavigationHandler from '../hooks/useNavigationHandler';

const NotFound = () => {
    const { t } = useLanguage();
    usePageTitle('notfound');
    const { handleLinkClick } = useNavigationHandler();

    return (
        <div className="inner-page-content">

            {/* 404 Section Start */}
            <div className="mxd-section mxd-section-inner-headline padding-default">
                <ServicesMarquee order={[5, 4, 3, 2, 1, 0]} />
                <div className="mxd-container grid-container">
                    <div className="mxd-block loading-wrap">
                        <div className="container-fluid px-0">
                            <div className="row gx-0 justify-content-center">
                                <div className="col-12 col-xl-8 text-center">
                                    <div className="notfound-content">
                                        <div className="notfound-error loading__item anim-uni-in-up" style={{
                                            fontSize: 'clamp(8rem, 20vw, 16rem)',
                                            fontWeight: 'var(--fw-bold)',
                                            lineHeight: '1',
                                            marginBottom: '2rem',
                                            opacity: '0.1'
                                        }}>
                                            {t('notfound.error')}
                                        </div>
                                        <h1 className="reveal-type loading__item" style={{
                                            fontSize: 'clamp(2.5rem, 5vw, 4rem)',
                                            marginBottom: '2rem'
                                        }}>
                                            {t('notfound.title')}
                                        </h1>
                                        <p className="anim-uni-in-up loading__item t-large" style={{
                                            maxWidth: '600px',
                                            margin: '0 auto 3rem',
                                            fontSize: 'clamp(1.125rem, 2vw, 1.5rem)'
                                        }}>
                                            {t('notfound.description')}
                                        </p>
                                        <div className="anim-uni-in-up loading__item">
                                            <Link
                                                to="/"
                                                className="btn btn-anim btn-primary btn-large slide-right-up"
                                                onClick={handleLinkClick}
                                            >
                                                <span className="btn-caption">{t('notfound.button')}</span>
                                                <i className="ph-bold ph-arrow-right"></i>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ServicesMarquee />
            {/* 404 Section End */}
        </div>
    );
};

export default NotFound;
